import {fetchNodeConfig} from "../../stageStatus/network/StageNetworkAPI";

export const CapabilityReducer = (state, action) => {
    switch (action.type) {
        case "GET_CAPABILITIES":
            return {...state, ...action.data};
        case "GET_STATION_CONFIG":
            const {dispatcher, baseUrl} = action.data;
            fetchNodeConfig(dispatcher, baseUrl);
            return state;
        case "RECEIVE_STATION_CONFIG":
            return {...state, ...action.data};
        case "RECEIVE_REFRESH_INTERVAL":
            return {
                ...state,
                stationConfig: {
                    ...state.stationConfig,
                    refreshInterval: action.data.refreshInterval
                }
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/global/reducers/CapabilityReducer.js